<template>
  <div :style="{height:height+'px',zIndex:zIndex}">
    <div :class="className" :style="{top:stickyTop+'px',zIndex:zIndex,position:position,width:width,height:height+'px'}">
      <slot>
        <div>sticky</div>
      </slot>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Sticky',
    props: {
      zIndex: {
        type: Number,
        default: 1
      },
      className: {
        type: String
      }
    },
    data() {
      return {
        stickyTop: 0,
        active: false,
        position: '',
        currentTop: '',
        width: undefined,
        height: undefined,
        child: null,
        stickyHeight: 0

      };
    },
    methods: {
      sticky() {
        if (this.active) {
          return
        }
        this.position = 'fixed';
        this.active = true;
        this.width = this.width + 'px';
        this.stickyTop = 44
      },
      reset() {
        if (!this.active) {
          return
        }
        this.position = '';
        this.width = 'auto'
        this.active = false
        this.stickyTop = 0
      },
      handleScroll() {
        this.width = this.$el.getBoundingClientRect().width;
        const offsetTop = this.$el.getBoundingClientRect().top;
        if (offsetTop < this.stickyTop) {
          this.sticky();
          return
        }
        this.reset()
      }
    },
    mounted() {
      this.height = this.$el.getBoundingClientRect().height;
      let parent = this.$el.parentElement
      for (let i = 0; i < 3; i++) {
        if (parent.className.indexOf('app-container') < 0) {
          parent = parent.parentElement
        } else {
          break
        }
      }
      parent.addEventListener('scroll', this.handleScroll);
    },
    destroyed() {
      let parent = this.$el.parentElement
      if (parent.className.indexOf('el-form') > -1) {
        parent = parent.parentElement
      }
      parent.addEventListener('scroll', this.handleScroll);
    }
  };
</script>



// WEBPACK FOOTER //
// index.vue?6ac3e560